export default "__VITE_ASSET__kmOb4s$J__"